import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { Article, ArticleAdditionalDataBlock } from '@lib/article';
import { IDeliveryReceiptItem } from './IDeliveryReceiptItem';

export class DeliveryReceiptArticle extends Article<IDeliveryReceiptItem> {
    public static fromDeliveryReceiptItem(item: IDeliveryReceiptItem): Article<IDeliveryReceiptItem> {
        const article = new DeliveryReceiptArticle();

        article.id = item.id.toString();
        article.name = item.name;
        article.supplierArticleNumber = item.articleNumberSupplier;
        article.quantity = +item.quantity;
        article.note = item.note;
        article.quantityUnit = item.orderUnit;
        article.contentUnit = item.contentUnit;
        article.numberOfContentUnitsPerOrderUnit = item.numberOfContentUnitsPerOrderUnit;
        article.customerArticleSku = item.customerArticleSku;
        article.manufacturerArticleSku = item.manufacturerArticleSku;
        article.manufacturer = item.manufacturer;
        article.type = item.tableName;
        article.description = item.shortDescription;
        article.position = item.positionReceipt;
        article.orderNumber = item.orderNumber;

        const positionBlock = new ArticleAdditionalDataBlock();
        if (item.positionOrder) {
            positionBlock.add(marker('Position Bestellung'), item.positionOrder);
        }
        article.additionalDataBlocks = [positionBlock];

        return article;
    }
}
